(() => {

    // Update cart recommendation on cart updates
    document.addEventListener("cart:change", () => {
    	setTimeout(() => {
    		document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",  {
    			bubbles: true,
    			detail: {
    				show_cart_note: false
    			}
    		}));
    	}, 300);
    });

    // Push notification icon in nav bar
    var update_notify_icon = () => {
        const icon = document.querySelector('.p42_notify_icon');
        icon.classList.remove('active');
        if (("Notification" in window)) {
          icon.classList.remove('hidden');
          if(Notification.permission === "granted" || Notification.permission === 'denied') {
            icon.classList.add('hidden');
          }
        } else {
          icon.classList.add('hidden');
        }
    };
    window.p42_ask_notify = () => {
      if (("Notification" in window)) {
        if (Notification.permission !== 'denied') {
          Notification.requestPermission((permission) => {
            update_notify_icon();
          });
        }
      }
    }
    update_notify_icon();

  // Remove the zifyapps logo
  var i = setInterval(() => {
    var e = document.querySelector(".zifyapps-sociallogin-wrapper-v2 img");
    if(e) {
      clearInterval(i);
      e.remove();
    }
  }, 100);
  var t = setTimeout(() => {
    clearInterval(i);
  }, 1000);

  // Testimonial shuffle
  var testimonial_list = document.querySelector(".testimonial-list");
  if (testimonial_list) {
    var testimonial_divs = Array.from(testimonial_list.querySelectorAll(".testimonial"));
    for (var i = testimonial_divs.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      [testimonial_divs[i], testimonial_divs[j]] = [testimonial_divs[j], testimonial_divs[i]];
    }
  
    // Limit the divs to only 3
    testimonial_divs = testimonial_divs.slice(0, 3);
  
    // Clear the testimonial_list
    while (testimonial_list.firstChild) {
      testimonial_list.removeChild(testimonial_list.firstChild);
    }
  
    // Append the first 3 shuffled divs back to the testimonial_list
    testimonial_divs.forEach(function (div) {
      testimonial_list.appendChild(div);
    });
  }
  
  
})();